import React, { useContext } from "react";
import "../styles/Ventana_Contacto.css";
import icon_facebook from "../assets/images/facebook.png";
import icon_whatsapp from "../assets/images/social.png";
import icon_youtube from "../assets/images/youtube.png";

import { ventanas } from "../App";

function Ventana_contacto() {
  const { ventana, setVentana } = useContext(ventanas);
  return (
    <div className="content-ventanaContacto">
      <div className="barra-contacto">
        <div className="btn-contacto">
          <img src={icon_whatsapp}></img>WhatsApp
        </div>
        <div className="btn-contacto">
          <img src={icon_facebook}></img>Facebook
        </div>
        <div className="btn-contacto">
          <img src={icon_youtube}></img>YouTube
        </div>
      </div>
      <div className="content-datos">
        <div className="content-mapa">
          <iframe
            src="https://www.google.com/maps/embed?pb=!4v1765143183066!6m8!1m7!1sXg742g0-ByyWOF10-6Kyeg!2m2!1d20.3921714074733!2d-99.96531747741803!3f87.2899541200841!4f2.4210966464907244!5f0.7820865974627469"
            width="600"
            height="450"
            style={{
              border: "0",
              borderRadius: "7px",
              width: "100%",
              height: "100%",
            }}
            allowfullscreen="none"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <div className="content-info">
          <div className="content-texto">
            <p>
              Nos Ubicamos en Av. Gandhi #8, Colonia La floresta, San Juan del
              Río, Querétaro.
            </p>
            <p>Trabajamos en horarios de 9:00am a 8:00pm de Lunes a Domingo.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Ventana_contacto;
